import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./showtimes.css";

Showtimes.propTypes = {
  theater: PropTypes.string,
  slug: PropTypes.string,
  showtimes: PropTypes.array,
};

export default function Showtimes(props) {
  const { theater, slug, showtimes } = props;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let rows = [];

    showtimes.forEach((showtime) => {
      let rowName = `${showtime.movie_format} - ${showtime.movie_version} - ${showtime.room_name}`;
      let rowAdded = rows.find((row) => row.name === rowName);

      if (rowAdded) {
        rowAdded.times.push(showtime);
      } else {
        rows.push({
          name: rowName,
          format: showtime.movie_format,
          version: showtime.movie_version,
          room: showtime.room_name,
          times: [showtime],
        });
      }
    });

    setRows(rows);
  }, [showtimes]);

  return (
    <div className="showtimes">
      {rows.map((row, index) => (
        <div className="showtimes-row" key={index}>
          <div className="showtimes-header">
            <p>Sala: {row.room}</p>
            <div>{row.format}</div>
            <div>{row.version}</div>
          </div>
          <div className="showtimes-times">
            {row.times.map((time, index) => (
              <Link
                to={`/${theater}/pelicula/${slug}/funcion/${time.id}`}
                key={index}
              >
                {time.hour_string}
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
